import { render, staticRenderFns } from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=template&id=52d275de&scoped=true"
import script from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetReferenceImagesPicker.vue?vue&type=style&index=0&id=52d275de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d275de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d275de')) {
      api.createRecord('52d275de', component.options)
    } else {
      api.reload('52d275de', component.options)
    }
    module.hot.accept("./AIChatWidgetReferenceImagesPicker.vue?vue&type=template&id=52d275de&scoped=true", function () {
      api.rerender('52d275de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetReferenceImagesPicker.vue"
export default component.exports